import { FR_GREY_300, FR_PR_BLUE } from '@shared/styles/vars';
import React from 'react';
import Switch from 'react-switch';

export const SwitchToggle = props => {
  return <Switch {...props} />;
};

SwitchToggle.defaultProps = {
  checkedIcon: false,
  height: 24,
  offColor: FR_GREY_300,
  onColor: FR_PR_BLUE,
  uncheckedIcon: false,
  width: 40,
};
